export const LOCKED = 'LOCKED';
export const UNSELECTED = 'UNSELECTED';
export const SELECTED = 'SELECTED';
